export enum PaymentOrigin {
  Online = "online",
  Totem = "totem",
}

export const paymentOriginLabelMap: Record<string, string> = {
  [PaymentOrigin.Online]: "Link",
  [PaymentOrigin.Totem]: "Totem",
};
